import { render, staticRenderFns } from "./GPS_list.vue?vue&type=template&id=673ae4f7&"
import script from "./GPS_list.vue?vue&type=script&lang=js&"
export * from "./GPS_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports